<template>
  <div>
    <el-menu class="el-menu-demo" mode="horizontal" background-color="#545c64" text-color="#fff" active-text-color="#ffd04b">
      <el-menu-item index="1" v-on:click="goHome">
         <img src="../../assets/logo-transparent.png" class="header-logo"/>
      </el-menu-item>
      <el-submenu index="2" class="pull-right">
        <template slot="title">
          <span v-if="username">
              Учетная запись: {{ username }}
          </span>
        </template>
        <el-menu-item index="2-1" v-on:click="manage">
          <template>
              <span class="icon is-small">
                <i class="el-icon-edit"></i>
              </span>
              <span> Редактировать профиль </span>
          </template>
        </el-menu-item>
        <el-menu-item index="2-2" v-on:click="logout">
            <span class="icon is-small">
              <i class="el-icon-upload2"></i>
            </span>
            <span> Выход из системы </span>
        </el-menu-item>
      </el-submenu>
      <span class="pull-right notifier" v-if="showNotifier">
        <el-badge :value="notifications" :max="99">
          <el-button icon="el-icon-message" size="mini" @click="openNotifications"></el-button>
        </el-badge>
      </span>
    </el-menu>
  </div>
</template>

<script>
  import config from '../../appsettings.js'
  export default {
    name: 'appheader',
    data() {
      return {
        username: "",
        email: "",
        user: {},
        notifications: 0,
        appname: config.APP_NAME,
        isAuthorized: true,
        WELCOME_URL: config.WELCOME_URL
      }
    },
    computed: {
      showNotifier: function() {
        return this.notifications > 0;
      }
    },
    methods: {
      logout() {
        //this.$localStorage.set('access_token', "");
        this.$manager.signoutRedirect()
          .catch(function(err) {
          console.log(err)
        })
      },
      openNotifications() {
        this.$router.push(config.NOTIFICATIONS_URL)
      },
      fetchData() {
        let self = this;
        let prefix = config.API_PREFIX;
        this.$gf.getOptions().then(options => {
          options.params = {
          };
          ///NOTIFICATIONS
          self.$http.get(`${prefix}notifications/notread`, options)
            .then(response => {
              this.notifications = response.data;
            })
            .catch(data => {
              self.$gf.checkError(data);
            });
        }).catch(err => {
          this.$gf.catchOptions();
        });
      },
      goHome() {
        this.$router.push(config.WELCOME_URL)
      },
      manage() {
        window.location.href = config.IS_PREFIX + 'manage'
      }
    },
    created() {
      Event.$on('notificationCountChange', () => this.fetchData());
      var self = this
      //Event.$on('notAuthorized', () => this.isAuthorized = false)
      this.$manager.getUser().then(user => {
        if (user && user.profile.given_name && user.profile.family_name ) {
          self.username = user.profile.given_name + " " + user.profile.family_name;
          this.isAuthorized = true;
        }
        if (user && user.profile.email) {
          self.email = user.profile.email;
          this.isAuthorized = true;
          this.fetchData();
        }
        if (!user) {
          this.isAuthorized = false;
        }
      })
    },
    beforeDestroy() {
      Event.$off('notificationCountChange');
    }
  }
</script>

<style scoped>
  .notifier {
    margin: 16px 10px 0px 0px;
  }
</style>

<style>
  .pull-right {
    float: right !important;
  }
  .header-logo {
    width: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/appheader.vue